import { createSelector, createSlice } from '@reduxjs/toolkit';
import { matchGetSkillTagsFulfilled, matchGetSkillTagsPending, matchGetSkillTagsRejected, } from '@/api/achievementTokensApiSlice';
import getUnionSkillTags from './utils/getUnionSkillTags';
const initialState = {
    ontologyTags: [],
    customTags: [],
    isCustomTagsLoading: false,
};
export const skillTagsSlice = createSlice({
    name: 'achievementTokens/skillTags',
    initialState,
    reducers: {
        setOntologyTags: (state, action) => {
            state.ontologyTags = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(matchGetSkillTagsFulfilled, (state, action) => {
            state.customTags = action.payload;
            state.isCustomTagsLoading = false;
        });
        builder.addMatcher(matchGetSkillTagsRejected, (state) => {
            state.isCustomTagsLoading = false;
        });
        builder.addMatcher(matchGetSkillTagsPending, (state) => {
            state.isCustomTagsLoading = true;
        });
    },
});
export const selectCustomTags = (state) => state.skillTags.customTags;
export const selectIsCustomTagsLoading = (state) => state.skillTags.isCustomTagsLoading;
const selectOntologyTags = (state) => state.skillTags.ontologyTags;
export const selectCombinedSkillTags = createSelector([selectCustomTags, selectOntologyTags], (skillTags, ontologyTags) => getUnionSkillTags(skillTags, ontologyTags));
export const { setOntologyTags } = skillTagsSlice.actions;
export default skillTagsSlice.reducer;
